import type { PaginationParams } from "@/types/api";

export function buildUrl<T extends object = PaginationParams>(
  baseUrl: string,
  path: string,
  params?: T
): string {
  const queryParams = new URLSearchParams();

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value === undefined || value === null || value === "") return;

      if (Array.isArray(value)) {
        value.forEach(v => queryParams.append(key, String(v)));
      } else {
        queryParams.append(key, String(value));
      }
    });
  }

  const queryString = queryParams.toString();
  return `${baseUrl}${path}${queryString ? `?${queryString}` : ""}`;
}
